import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, Button, Box, Typography, Autocomplete, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg"
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import { fetchCantines } from "../../features/cantine/cantineThunk";
import { fetchProduzioineTipodicontenitore } from "../../features/produzioniFormData/produzioniFormDataThunk";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

const TableInputAffinamento = ({ option, rows, setRows, activeStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const cantineOptions = useSelector((state) => state.cantine.cantines) || [];
    const tipodicontenitoreOptions = useSelector((state) => state.produzioniForm.tipodicontenitore) || [];
    const { control, setValue, formState: { errors } } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, datetime: null, cantina: "", tipo: "", temperature: "", product: "" },
    //     { id: 2, datetime: null, cantina: "", tipo: "", temperature: "", product: "" },
    // ]);

    useEffect(()=>{
        dispatch(fetchCantines());
        dispatch(fetchProduzioineTipodicontenitore());
    },[dispatch])

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_affinamento: null, cantina_id: "", tipo_di_contenitore: "", temperatura_affinamento: "", umidita_cantina: "" },
        ]);
    };
    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "affinamento"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };
    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            {/* Heading */}
            <h3 className="sectiontitleSmall">Affinamento</h3>

            {/* Column Titles */}
            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid  size={.5}><Typography>ID</Typography></Grid>
                <Grid  size={3}><Typography>Data inizio affinamento e invecchiamaento</Typography></Grid>
                <Grid  size={1.8}><Typography>Cantina</Typography></Grid>
                <Grid  size={1.8}><Typography>Tipo di contenitore</Typography></Grid>
                <Grid  size={2.4}>
                    <Box className="inputBoxIcon heading">
                        <p>
                            Temperatura affinamento
                        </p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
                <Grid  size={2.4}>
                    <Box className="inputBoxIcon heading">
                        <p>
                            Umidità cantina
                        </p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {/* Dynamic Rows */}
            {rows?.map((row, index) => (
                <>

                    <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
                        <Grid size={.5}>
                            <TextField
                                className="customTextBox"
                                label="ID"
                                size="small"
                                value={row?.id || index}
                                disabled
                            />
                        </Grid>

                        <Grid  size={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`datetime-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DatePicker
                                            className='datePickerField'
                                            label="Data inizio affinamento e invecchiamaento"
                                            value={row.date_affinamento ? dayjs(row.date_affinamento) : null}
                                            onChange={(newValue) => {
                                                const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                                handleInputChange(index, "date_affinamento", formattedDate);
                                                field.onChange(formattedDate);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!errors[`datetime-${index}`]}
                                                    helperText={errors[`datetime-${index}`]?.message}
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid  size={1.8}>
                            <Autocomplete
                                options={cantineOptions}
                                getOptionLabel={(option)=> option.name}
                                value={cantineOptions.find((option) => option.id == row.cantina_id) || null}
                                onChange={(event, newValue) => handleInputChange(index, "cantina_id", newValue.id)}
                                renderInput={(params) => (
                                    <TextField {...params} className="customTextBox autoCompleteTextBox" label="Cantina" size="small" />
                                )}
                            />
                        </Grid>

                        <Grid  size={1.8}>
                            <Autocomplete
                                options={tipodicontenitoreOptions}
                                value={row.tipo_di_contenitore}
                                onChange={(event, newValue) => handleInputChange(index, "tipo_di_contenitore", newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} className="customTextBox autoCompleteTextBox" label="Tipo di contenitore" size="small" />
                                )}
                            />
                        </Grid>
                        <Grid  size={2.4}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    className="customTextBox"
                                    label="Temperatura affinamento"
                                    value={row.temperatura_affinamento}
                                    onChange={(e) => handleInputChange(index, "temperatura_affinamento", e.target.value)}
                                    size="small"
                                />
                                <Wifi className="wifiIcon" />
                            </Box>

                        </Grid>
                        <Grid  size={2.4}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    className="customTextBox"
                                    label="Umidità cantina"
                                    value={row.umidita_cantina}
                                    onChange={(e) => handleInputChange(index, "umidita_cantina", e.target.value)}
                                    size="small"
                                />
                                <Wifi className="wifiIcon" />
                            </Box>

                        </Grid>
                        <Grid  size={.1}>
                            <MenuWithPDF
                                options={option}
                                handleDelete={(event) => {
                                    event?.stopPropagation();
                                    handleDelete(index);
                                }}
                            />
                        </Grid>
                    </Grid>

                </>
            ))}

            {/* Add Button */}
            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon

                /> aggiungi lotto per affinamento e invecchiamento
            </Button>

        </Box>
    );
};

export default TableInputAffinamento;
